// removed by extract-text-webpack-plugin
module.exports = {"container":"Krmchy1","message":"_323c2w8"};


//////////////////
// WEBPACK FOOTER
// ./template/components/WelcomeMat/ValueProposition.css
// module id = ./template/components/WelcomeMat/ValueProposition.css
// module chunks = client.sitechrome